import './OnlineEventsApi';

import Request from '@hotmart/request';

class OnlineEventService {
  resendAccess = () =>
    Request('resend.access', {
      search: {
        filters: [{ _type: 'simple', query: '' }]
      }
    });
}

export default new OnlineEventService();
